import ModalRow from './ModalRow';

export default class TrashModal {
  constructor(modal) {
    this.modal = modal;
    this.total = modal.querySelector('[data-total-price]');
    this.quantity = modal.querySelector('[data-total-quantity]');
    this.rows = modal.querySelectorAll('.panel');
    this.activeRows = [];
    this.isOpen = false;
    this.init();
  }

  init() {
    this.modalEvents();
    let firstRow = new ModalRow(this.modal, this.rows[this.rows.length - 1]);
    this.activeRows.push(firstRow);
    firstRow.updateInOut();
    this.modalTotal();
  }

  customEvent() {
    let event = new Event('modalRowUpdate');
    document.dispatchEvent(event);
  }

  checkApplyToAll() {

    this.activeRows.forEach( (row) => {
      let button = row.row.querySelector('.apply-to-all');

      if(this.activeRows.length > 1) {
        button.classList.add('enabled');

        button.addEventListener( 'click', (e) => {
          e.preventDefault();
          let defaultInputs = [];
          let selects = row.row.querySelectorAll('select');
          let radios = row.row.querySelectorAll('input[type="radio"]');
          let count = 0;

          selects.forEach( (select) => {
            let selectObj = {
              order: count,
              value: select.value,
              checked: select.checked
            };
            defaultInputs.push(selectObj);
            count++;
          } );

          radios.forEach( (radio) => {
            let radioObj = {
              order: count,
              value: radio.value,
              checked: radio.checked
            };
            defaultInputs.push(radioObj);
            count++;
          } );

          this.applyToAll(defaultInputs);
        } );

      } else {
        button.classList.remove('enabled');
      }

    } );
  }

  applyToAll(defaultInputs) {
    console.log(defaultInputs);
    this.activeRows.forEach( (row) => {

      let inputs = [];
      let selects = row.row.querySelectorAll('select');
      let radios = row.row.querySelectorAll('input[type="radio"]');

      selects.forEach( (select) => {
        inputs.push(select);
      } );

      radios.forEach( (radio) => {
        inputs.push(radio);
      } );

      defaultInputs.forEach( (input) => {
        inputs[input.order].value = input.value;
        inputs[input.order].checked = input.checked;
      } );

      row.updateInOut();
      row.rowTotal();
    } );

    this.customEvent();
    this.modalTotal();
  }

  modalEvents() {
    let add = this.modal.querySelector('.add-row');
    let remove = this.modal.querySelector('.remove-row');
    let counter = this.modal.querySelector('.row-count');
    let closeBtn = this.modal.querySelector('.btn-close');
    let applyBtn = this.modal.querySelector('.btn-apply');
    let overlay = this.modal.querySelector('.trash-calculator-form-overlay');

    add.addEventListener('click', (e) => {
      e.preventDefault();
      let newRow = this.activeRows[0].addRow();
      let newInstance = new ModalRow(this.modal, newRow);
      this.activeRows.push(newInstance);
      counter.innerHTML =  Number(counter.innerText) + 1;
      this.checkApplyToAll();
      newInstance.customEvent();
    } );

    remove.addEventListener('click', (e) => {
      e.preventDefault();
      if(this.activeRows.length > 1) {
        this.activeRows[this.activeRows.length - 1].removeRow();
        this.activeRows.pop();
        counter.innerHTML =  Number(counter.innerHTML) - 1;
      }
      this.checkApplyToAll();
      this.activeRows[0].customEvent();
    } );

    overlay.addEventListener('click', (e) => {
      e.preventDefault();
      this.close();
    } );

    closeBtn.addEventListener( 'click', (e) => {
      e.preventDefault();
      this.close();
    } );

    applyBtn.addEventListener( 'click', (e) => {
      e.preventDefault();
      this.close();
    } );

    document.addEventListener('modalRowUpdate', () => {
      this.modalTotal();
    });

    document.addEventListener('keyup', (event) => {
      if (event.defaultPrevented) {
        return;
      }

      if(this.isOpen) {
        let key = event.key || event.keyCode;

        if (key === 'Escape' || key === 'Esc' || key === 27) {
          this.close();
        }
      }
    });

  }

  modalTotal() {
    let total = this.getTotal();
    let total_l = this.getTotalL();

    this.total.innerHTML  = total;
    this.quantity.innerHTML = total_l;
  }

  getTotal() {
    let total = 0;
    this.activeRows.forEach( (instance) => {
      total = total + Number(instance.row.dataset.total);
    } );

    return total;
  }

  getTotalL(){
    let total_l = 0;
    this.activeRows.forEach( (instance) => {
      total_l = total_l + Number(instance.row.dataset.total_l);
    } );

    return total_l;
  }

  open() {
    this.modal.classList.add('open');
    this.isOpen = true;
    lockBodyScroll();
  }

  close() {
    this.modal.classList.remove('open');
    this.isOpen = false;
    unlockBodyScroll();

    jQuery('.floating-helper.step-3').addClass('open');

  }

  removeModal() {
    this.modal.remove();
  }
}

function lockBodyScroll() {
  const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
  const body = document.body;
  body.style.position = 'fixed';
  body.style.width = '100%';
  body.style.top = `-${scrollY}`;
}

function unlockBodyScroll() {
  const body = document.body;
  const scrollY = body.style.top;
  body.style.position = '';
  body.style.top = '';
  window.scrollTo(0, parseInt(scrollY || '0') * -1);
}

window.addEventListener('scroll', () => {
  document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
});
